import script from "./DemandCalendarArticle.vue?vue&type=script&setup=true&lang=ts"
export * from "./DemandCalendarArticle.vue?vue&type=script&setup=true&lang=ts"

import "./DemandCalendarArticle.vue?vue&type=style&index=0&id=4070662f&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4070662f"]])

export default __exports__